module.exports = __webpack_public_path__ + "static/media/Intelo-Light.57911e43.ttf";